// Resolve the course by its canonical name on Training, where the member's
// available course IDs are already loaded. IDs differ between environments.
export const LIFE_PLAN_COURSE_PATH = '/training?course=life-plan#courses';
